import { Upload, message } from "antd";
import { useIntl, FormattedMessage } from "react-intl";
import "./Base/Images/images.scss";
import type { GetProp, UploadProps } from 'antd';

const allowedFileTypes = ["image/png", "image/jpg", "image/jpeg", "image/webp"];

type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];
type Props = {
  handleDrop: (files: FileType[]) => void;
};

const ImageUploader = ({ handleDrop }: Props) => {
  const [messageApi, contextHolder] = message.useMessage()
  const { formatMessage } = useIntl();

  return (
    <>
      {contextHolder}
      <Upload.Dragger
        className="dropzone"
        accept={allowedFileTypes.join(",")}
        showUploadList={false}
        beforeUpload={(file: FileType) => {
          if (!allowedFileTypes.includes(file?.type)) {
            messageApi.error(formatMessage({ id: "image.upload.type.invalid.error" }));
          } else {
            handleDrop([file]);
          }

          return false;
        }}
      >
        <FormattedMessage id="image.upload.help" />
      </Upload.Dragger>
    </>
  )
};

export default ImageUploader;
